import React, { Component, Fragment } from 'react'
import AudioComponent from '../AudioComponent'
import { translate } from 'react-i18next'
import Pagination from 'antd/lib/pagination'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import VoiceItem from '../VoiceItem'
import Favourite from '../Favourite'
import Loader from '../Loader'
import { resolutions } from '../../utils/constants'
import FilterContainer from '../FilterContainer'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import { getLanguagesFromVoices, getAgesFromVoices } from '../../helpers/voice.helper'
import { filterByParams } from '../../helpers/filterVoices.helper'
import './index.sass'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

const ITEM_PER_PAGE = 18

class Voices extends Component {
  state = {
    language: [],
    gender: [],
    age: [],
    width: window.innerWidth,
    page: 1,
  }
  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  componentWillUnmount() {
		const {
      actions: { setPlayingStatus, toggleVisibleAudioPlayer },
    } = this.props
    setPlayingStatus(false)
    toggleVisibleAudioPlayer(false)
    window.removeEventListener('resize', this.updateDimensions)
	}
	
  componentDidMount = () => {
    const {
      voices,
      voiceDescriptions,
      actions: { getVoicesDescr },
    } = this.props
    window.addEventListener('resize', this.updateDimensions)
    if (voices.length === 0 || Object.keys(voiceDescriptions).length === 0) {
      getVoicesDescr()
    }
  }

  handleChangeFilter = (e, optionName) => {
    const option = optionName.toLowerCase()
    this.setState(
      {
        [option]: e,
        page: 1,
      },
      () => this.stopPlayer()
    )
  }

  stopPlayer = () => {
    const {
      actions: { setPlayingStatus },
    } = this.props
    setPlayingStatus(false)
  }

  clearAllFilters = filterName => {
    this.setState(
      {
        [filterName]: [],
        page: 1,
      },
      () => this.stopPlayer()
    )
  }

  onHandlePaginationChange = page => {
    this.setState(
      {
        page,
      },
      () => this.nodeList.scrollTo({ top: 0, behavior: 'smooth' })
    )
  }

  render = () => {
    const {
      voices,
      loading,
      actions: {
        toggleFavoriteVoice,
        changeModalVisibility,
        setPlayList,
        toggleVisibleAudioPlayer,
        setPlayingStatus,
        setPlayingVoiceId,
        setChoosenVoice,
      },
      t,
      lng,
      isAudioVisible,
      currentVoiceId,
      isAudioPlaying,
      voiceDescriptions,
    } = this.props
    
    const { language, gender, age, width, page } = this.state
    const filteredVoices = filterByParams(voices, language, gender, age)
    const languages = getLanguagesFromVoices(voices)
    const ages = getAgesFromVoices(voices)
    const dd = page === 1 ? 0 : page - 1
    const paginationedItems = filteredVoices.slice(dd * ITEM_PER_PAGE, page * ITEM_PER_PAGE)
    setPlayList(paginationedItems)
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{t('meta.voices.title')}</title>
          <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/voices" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/voices" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/voices" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/voices" />
          <meta name="description" content={t('meta.voices.descr')} />
          {lng === 'en' && <meta name="keywords" content={t('meta.voices.keywords')} />}
          {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/voices'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/voices`} />}
          <meta property="og:title" content={t('meta.voices.title')} />
          <meta property="og:description" content={t('meta.voices.descr')} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/voices': `https://unimedia.io/${lng}/voices`} />
          <script type="application/ld+json">
          {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('meta.voices.descr')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.voices')}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'voices'} />
        <div className="voices-page container overflow-y" ref={ref => (this.nodeList = ref)} id={'voices'}>
          <div className={isAudioVisible ? 'container-wrapper extra-padding' : 'container-wrapper'}>
          <Breadcrumbs pathname={window.location.pathname} color='white'/>
						<h1 className="main-title">{t('voices.title')}</h1>
            <div className="voices-controls">
              {width < resolutions.tablet && (
                <FilterContainer
                  handleChangeFilter={this.handleChangeFilter}
                  numberOfResults={filteredVoices.length}
                  languages={languages}
                  ages={ages}
                  opt={{ gender, age, language }}
                  clearAllFilters={this.clearAllFilters}
                  toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
                  setPlayingStatus={setPlayingStatus}
                  isAudioVisible={isAudioVisible}
                />
              )}
              <Favourite toggleFavoriteVoice={toggleFavoriteVoice} />
            </div>
            {width > resolutions.tablet && (
              <FilterContainer
                ages={ages}
                opt={{ gender, age, language }}
                languages={languages}
                handleChangeFilter={this.handleChangeFilter}
                clearAllFilters={this.clearAllFilters}
                isAudioVisible={isAudioVisible}
              />
            )}
            {loading ? (
              <Loader />
            ) : paginationedItems.length > 0 ? (
              <Fragment>
                 <div className='no-ai-notification'>
                  <p className='no-ai-title'>{t(`voiceDetail.noAI`)}</p>
                  <p className='no-ai-description'>{t(`voiceDetail.noAIDescr`)}</p>
              </div>
                <ul className="voices-list">
                  {paginationedItems.map(elem => (
                    <VoiceItem
                      key={elem.id}
                      changeModalVisibility={changeModalVisibility}
                      voiceItem={elem}
                      toggleFavoriteVoice={toggleFavoriteVoice}
                      toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
                      setPlayingStatus={setPlayingStatus}
                      currentPlayingVoice={{ currentVoiceId, isAudioPlaying }}
                      setPlayingVoiceId={setPlayingVoiceId}
                      setChoosenVoice={setChoosenVoice}
                      hasVoiceSescr={
                        // lng==='ru' ?
                        // !EXCLUDED_DE_VOICES.includes(elem.language) && voiceDescriptions[elem.language.toLowerCase().split(' ').join('-')] :
                        voiceDescriptions[elem.language.toLowerCase().split(' ').join('-')] }
                    />
                  ))}
                  <p className="warn-message body-light">
                    {t('general.voiceDetails')}
                    <button onClick={changeModalVisibility}>{t('general.checkIt')}</button>
                  </p>
                </ul>
                <Pagination
                  current={page}
                  className="pagination"
                  size="small"
                  onChange={this.onHandlePaginationChange}
                  hideOnSinglePage
                  defaultCurrent={1}
                  pageSize={ITEM_PER_PAGE}
                  total={filteredVoices.length}
                />
                {isAudioVisible && <AudioComponent />}
              </Fragment>
            ) : (
              <h6 className="message">{t('voices.noResults')}</h6>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  voices: state.voices,
  voiceDescriptions: state.voiceDescriptions,
  loading: state.app.loading,
  isAudioVisible: state.audioPlayer.isVisible,
  currentVoiceId: state.audioPlayer.currentVoiceId,
  isAudioPlaying: state.audioPlayer.isPlaying,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Voices)
)
